export default {
    bindings: {
        orders: '<',
        timeframe: '@'
    },
    controller: 'orderHistoryTimeframeController',
    template: require('../views/order.history.timeframe.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/user/components/order.history.timeframe.component.js